import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const articleSlugs = [
  'best-allchinabuy-spreadsheet',
  'free-allchinabuy-spreadsheet',
  'allchinabuy-spreadsheet-2026-guide',
  'allchinabuy-yupoo-spreadsheet',
  'allchinabuy-shoes-spreadsheet',
  'allchinabuy-clothing-spreadsheet',
  'allchinabuy-seller-spreadsheet',
  'allchinabuy-trusted-sellers',
  'allchinabuy-buying-guide',
  'allchinabuy-safety-guide',
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articleSlugs.map((slug) => ({
    path: `/${slug}`,
    element: <ArticlePage />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;